export default "__VITE_ASSET__DzoSyf5S__"